import { ReactElement } from 'react';
import { ResultsProductList as CoreResultsProductList } from '@client/catalog/components/ResultsProductList/ResultsProductList';
import type { Props } from '@client/catalog/components/ResultsProductList/ResultsProductList.types';
import { useTranslate } from '@client/i18n/hooks/useTranslate';

export const ResultsProductList = (props: Props): ReactElement => {
  const t = useTranslate();
  const priceWithVatLabel = t(
    'Comparison Price<br />(incl. VAT)',
    {},
    'Compare Price (Vergleichspreis) with VAT',
  );

  return <CoreResultsProductList {...props} priceWithVatLabel={priceWithVatLabel} />;
};
